module.exports = __webpack_public_path__ + "static/img/2areaB_20.09ba08a.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/2areaB_20.png
// module id = 1147
// module chunks = 1